import React from 'react'
import Navbar from '../../layout/Navbar'
import "./Contact.css"

const Dashboard = () => {
  return (
        <div id='page'>
      <div id='about-page'>
      <Navbar />
      <div id='about-hero'>
        <h5>CONTACT US</h5>
        <h2>LET'S' <span>CONNECT</span></h2>
        <p id='about-text'>For all your outdoor marketing needs, get in touch with Vwrap today and let us help you elevate your brand to the next level!</p>
      </div>
    </div>
       
    </div>
  )
}

export default Dashboard
